import { getLogoUrl } from "@/constants/integration-logos";
import { ONBOARDING_USE_CASES } from "@/constants/onboarding";

export function WelcomeScreen() {
	return (
		<div className="space-y-6">
			{/* Heading */}
			<div className="space-y-3 text-center">
				<h2 className="text-2xl font-semibold tracking-tight">Welcome to m8tes!</h2>
				<p className="text-base text-muted-foreground">
					Automate the tasks you'd give a colleague.
				</p>
			</div>

			{/* Perfect For */}
			<div className="space-y-3">
				<h3 className="text-sm font-medium text-muted-foreground">Perfect for:</h3>
				<div className="grid gap-3">
					{ONBOARDING_USE_CASES.map((useCase) => (
						<div
							key={useCase.title}
							className="flex items-start gap-3 rounded-lg border bg-card p-4"
						>
							<div className="flex shrink-0 items-center gap-1">
								{useCase.integrations.map((i) => (
									<div
										key={i.id}
										className="flex size-8 items-center justify-center rounded-lg bg-primary/10"
									>
										<img
											src={getLogoUrl(i.logoKey)}
											alt={`${i.name} logo`}
											className="size-5 object-contain"
										/>
									</div>
								))}
							</div>
							<div className="min-w-0 flex-1">
								<p className="text-sm font-medium">{useCase.title}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
